import axios from "axios";
const packageJson = require("../../package.json");

const createSignature = () => {
  const secretKey = "5d928cd2-77d1-4415-abbb-4f225f40ee65";
  return secretKey;
};

// Create a global axios instance
const api = axios.create({
  baseURL: packageJson.apiUrl,
});

// Interceptor to inject headers globally
api.interceptors.request.use((config) => {
  
  const signature = createSignature();
  const profile = localStorage.getItem("userProfile");
  let userInformationId = null;

  if (profile) {
    try {
      const parsed = JSON.parse(profile);
      userInformationId = parsed.userInformationId;
    } catch (err) {
      console.error("Failed to parse userProfile:", err);
    }
  }

  config.headers["X-Growniverse-Signature"] = signature;
  if (userInformationId) {
    config.headers["X-Growniverse-UserInformationId"] = userInformationId;
  }

  return config;
});

export default api;
